import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return (resource) => present(repository.getCalendarExportLinks(resource));
}

export type { Interactor };

export { createInteractor };
